
import { defineComponent } from "vue";
import { ITuitionPriceLinesModel } from "@/interfaces/modules";
import TuitionPriceLinesService from "@/api/Collection/TuitionPriceLinesService";
import TuitionPriceListsService from "@/api/Collection/TuitionPriceListsService";
import ICourseGroupsServices from "@/api/Aula/CourseGroupsService";
import type { ITuitionPriceListsModel, ICourseGroupsModel } from "@/interfaces/modules";
import store from "@/store";

export default defineComponent({
  name: "TuitionPriceLinesContent",
  data() {
    return {
      priceLists: [] as ITuitionPriceListsModel[],
      academicGroups: [] as ICourseGroupsModel[],
      form: {
        loading: true,
        dialog: false,
        valid: false,
        wasValidated: false,
        record: {} as ITuitionPriceLinesModel,
        rules: {
          required: [(v: any) => !!v || "Este campo es requerido"],
        },
      },
      table: {
        filters: { search: "" },
        currentPage: 1,
        loading: false,
        headers: [
          { key: "Concept", label: "Concepto", sortable: true },
          { key: "Amount", label: "Valor", sortable: true },
          { key: "CreatedByFormat", label: "Creación", sortable: true },
          { key: "ModifiedByFormat", label: "Última modificación", sortable: true },
          { key: "action", label: "Acciones", sortable: false },
        ],
        records: [] as ITuitionPriceLinesModel[],
        rowsPerPage: 10,
      } as any,
    };
  },
  watch: {
    'form.record.PriceListId'(val: any) {
      this.form.wasValidated = !val || !this.form.record.PriceListId;
    }
  },
  computed: {
    filteredItems(): any {
      const q = this.table.filters.search?.toLowerCase() || "";
      return q
        ? this.table.records.filter((item: ITuitionPriceLinesModel) =>
          [item.Concept, item.Amount]
            .filter(Boolean)
            .some((v) => String(v).toLowerCase().includes(q))
        )
        : this.table.records;
    },
    rows(): number {
      return this.table.records?.length || 0;
    },
  },
  async mounted() {
    await this.load();
    this.priceLists = await TuitionPriceListsService.GetPriceLists();
    this.academicGroups = await ICourseGroupsServices.GetCourseGroups();

  },
  methods: {
    async load() {
      this.table.loading = true;
      this.table.records = await TuitionPriceLinesService.GetPriceLines();
      this.table.loading = false;
    },
    async edit(data: ITuitionPriceLinesModel) {
      this.form.record = await TuitionPriceLinesService.GetPriceLineById({ Id: data.Id } as any);
      this.form.dialog = true;
    },
    openModal() {
      this.form.record = {
        Id: 0,
        PriceListId: 0,
        AcademicGroupId: 0,
        Concept: "",
        Amount: 0,
        IsRecurring: false,
        Periods: 1,
        CreatedBy: 0,
        CreatedDate: "",
      } as ITuitionPriceLinesModel;
      this.form.dialog = true;
    },
    async handleSubmit(event: Event) {
      event.preventDefault();
      this.form.dialog = false;
      await TuitionPriceLinesService.PostPriceLine(this.form.record);
      store.dispatch("core/popupDialog", {
        text: "Registro completado con éxito.",
        type: "success",
        showCancelButton: false,
      });
      this.load();
    },
  },
});
